import request from '@/utils/request'

export function chinaTravel(query) {
    return request({
        url: '/bdBonusHisMemChina/chinaTravel',
        method: 'get',
        params: query
    })
}
